import axios from "../utils/axios-interceptor";

export const getCoboltojavaApi = async() => {
  try {
    const res = await axios.get("/coboltojava_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getdb2sqltotsqlApi = async() => {
  try {
    const res = await axios.get("/db2sql_to_tsql");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getBteqtopysparkApi = async() => {
  try {
    const res = await axios.get("/bteqtopyspark_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getCpptorustApi = async() => {
  try {
    const res = await axios.get("/cpptorust_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getctorustApi = async() => {
  try {
    const res = await axios.get("/ctorust_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getPytocppApi = async() => {
  try {
    const res = await axios.get("/pytocpp_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getcpptogoApi = async() => {
  try {
    const res = await axios.get("/cpptogo_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getPhptonodejsApi = async() => {
  try {
    const res = await axios.get("/phptonodejs_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getdnettoflaskApi = async() => {
  try {
    const res = await axios.get("/dnettoflask_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getsqlservertomysqlApi = async() => {
  try {
    const res = await axios.get("/sqlservertomysql_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getreacttoangularApi = async() => {
  try {
    const res = await axios.get("/reacttoangular_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const gettftopytorchApi = async() => {
  try {
    const res = await axios.get("/tftopytorch_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getETLTooltoDatapipelineApi = async() => {
  try {
    const res = await axios.get("/ETLTooltoDatapipeline_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getCOBOLtoSQLApi = async() => {
  try {
    const res = await axios.get("/COBOLtoSQL_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getPLSQLtoPythonApi = async() => {
  try {
    const res = await axios.get("/PLSQLtoPython_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getPostgreSQLtoMSAccessApi = async() => {
  try {
    const res = await axios.get("/PostgreSQLtoMSAccess_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getOracletoPostgreSQLApi = async() => {
  try {
    const res = await axios.get("/OracletoPostgreSQL_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getAssemblytoCApi = async() => {
  try {
    const res = await axios.get("/AssemblytoC_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getCtoEmbeddedCApi = async() => {
  try {
    const res = await axios.get("/CtoEmbeddedC_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getXamarinToKotlinApi = async() => {
  try {
    const res = await axios.get("/XamarinToKotlin_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getHadoopToSparkApi = async() => {
  try {
    const res = await axios.get("/HadoopToSpark_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getJavaToAngularApi = async() => {
  try {
    const res = await axios.get("/JavaToAngular_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getJenkinsToAzurePipelinesApi = async() => {
  try {
    const res = await axios.get("/JenkinsToAzurePipelines_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getCircleCIToGitLabCIApi = async() => {
  try {
    const res = await axios.get("/CircleCIToGitLabCI_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getPerlToPHPApi = async() => {
  try {
    const res = await axios.get("/PerlToPHP_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getRailsToDjangoApi = async() => {
  try {
    const res = await axios.get("/RailsToDjango_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getGoogleCloudToAWSApi = async() => {
  try {
    const res = await axios.get("/GoogleCloudToAWS_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getAWSLambdaToAzureFunctionsApi = async() => {
  try {
    const res = await axios.get("/AWSLambdaToAzureFunctions_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getMicrosoftDynamicsToNetSuiteApi = async() => {
  try {
    const res = await axios.get("/MicrosoftDynamicsToNetSuite_scenarios");
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

